import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { VisualizeCasierComponent } from './visualize-casier.component';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';




@NgModule({
  imports: [CommonModule,NgxQRCodeModule ],
  declarations: [VisualizeCasierComponent],
  exports: [VisualizeCasierComponent],
})
export class VisualizeCasierModule {}
